import { h } from "preact";

/** Interfaces **/
export interface StateChipProps {
  data: StateData;
  className?: string;
  icon?: string;
}

export interface StateData {
  id: number;
  name: string;
  icon: string;
}

export default function StateChip({ data, className, icon }: StateChipProps) {
  /** Metods **/
  const getState = () => {
    switch (data.id) {
      case 1:
        return { label: data.name, variant: "warning" };
      case 2:
        return { label: data.name, variant: "info" };
      case 3:
        return { label: data.name, variant: "warning" };
      case 4:
        return { label: data.name, variant: "error" };
      case 5:
        return { label: data.name, variant: "success" };
      default:
        return { label: data.name, variant: "info" };
    }
  };

  /** Variables **/
  const { label, variant } = getState();

  /** Render **/
  return (
    <span
      className={`whitespace-nowrap rounded-full px-4 py-2 text-sm leading-none bg-${variant}-50 text-${variant}-600 ${className ?? ""}`}
    >
      {icon && <i className={`far fa-${icon} mr-1`} />}
      {label}
    </span>
  );
}
